export enum AppRefreshStatus {
    Idle = 'Idle',
    Invalidated = 'Invalidated',
    InProgress = 'InProgress',
    Hide = 'Hide'
}